import type { ExpressionNode, ExpressionNodConstructor } from '../expression.js';


export const expressionTypes: Map<string, ExpressionNodConstructor<ExpressionNode>> = new Map();
